import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PortalService } from './portal.service';
import { Observable } from 'rxjs';
import { Hint } from '../models/hint.model';

@Injectable({
  providedIn: 'root',
})
export class HintService {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getHints(): Observable<any> {
    return this.http.get<Hint>(PortalService.ApiUrl + '/hints?limit=1000');
  }
}
